import AmountsTable from './AmountsTable';

export default AmountsTable;